import { useQuery } from '@apollo/client';
import { useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import DashboardWrap from '../../components/DashboardWrap';
import PropertyComp from '../../components/PropertyComp';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';

import { GET_ADMIN_LOAN_BY_ID } from '../../graphql/admin_queries';
import { cleanUpAdminSingleLoanRecord } from '../../utils/helpers';
import { AdminRouteName } from '../CONSTANTS';
import AdminActionedRecordDetails from '../../components/AdminActionedRecordDetails';

import LoanSummary from './LoanSummary';
import RepaymentSchedule from '../AdminRepaymentDetails/RepaymentSchedule';
import PermissionDenied from '../PermissionDenied';

import GoBackIcon from '../../svgs/GoBackIcon';

import './AdminLoanDetails.scss';
import EmptyPageLoader from '../../components/EmptyPageLoader';

const AdminLoanDetails = () => {
  const history = useHistory();
  const { loanId } = useParams<{ loanId: string }>();
  const { data, refetch, loading } = useQuery<
    {
      getLoanCa: any;
    },
    { id: string }
  >(GET_ADMIN_LOAN_BY_ID, { variables: { id: loanId } });

  const loan = useMemo(() => data?.getLoanCa, [data]);
  const [showAdminActionInfo, setShowAdminActionInfo] = useState(true);
  const payload = cleanUpAdminSingleLoanRecord(loan);
  const property = payload?.property || [];
  // const shouldShowCancel = ['PENDING'].includes(payload?.status);
  const isCancelled = ['CANCELLED'].includes(payload?.status);
  return (
    <DashboardWrap>
      <RolesAndPermissionGuard permissionName="can-view-loan-details" hasErrorTemplate={<PermissionDenied height="100vh" />}>
        <div className="loan-details-dashboard-loader" style={{ display: loading ? 'block' : 'none' }}>
          <EmptyPageLoader />
        </div>

        <div className="loan-details-cover" style={{ display: loading ? 'none' : 'block' }}>
          <div className="title">
            <GoBackIcon onClick={() => history?.goBack()} />
            Loans
          </div>
          <div className="loan-ref-id-and-badge">
            <span className="loan-ref-span">Loan Ref:</span>
            <span className="ref-no-span">{payload?.refNo}</span>
            <div className="loan-badge-span">Canada Rent</div>
          </div>

          <LoanSummary payload={payload} refetch={refetch} />
          {
            payload?.loanSchedules?.length ? <RepaymentSchedule payload={payload} refetchLoan={refetch} /> : ''
          }

          <div style={{
            display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'space-between', marginTop: '32px',
          }}
          >
            {
              property && (
              <div>
                <PropertyComp property={property} width="420px" />
              </div>
              )
            }

            {loan?.approvedByAdmin
            && showAdminActionInfo && (
            <div>
              <AdminActionedRecordDetails
                recordName={isCancelled ? 'Credit Request Denial!' : 'Credit Request Approval!'}
                recordTitle="request"
                action={isCancelled ? 'denied' : 'approved'}
                lastName={loan?.approvedByAdmin?.lastName}
                firstName={loan?.approvedByAdmin?.firstName}
                routePath={AdminRouteName.rentCollectionRoute}
                tableTitle="Credit Request"
                onClose={() => setShowAdminActionInfo(false)}
              />
            </div>
            )}
          </div>

        </div>
      </RolesAndPermissionGuard>

    </DashboardWrap>
  );
};

export default AdminLoanDetails;
